import ApiBase from 'Services/Api/ApiBase';

class DefaultApiBase extends ApiBase {}

export default new DefaultApiBase();
